import { actionGenerator } from "utils";

const PREFIX = "HOME";

export const VALIDATE_CAMPAIGN = actionGenerator.genActionTypes(
  `${PREFIX}_VALIDATE_CAMPAIGN`
);

export const VALIDATE_CODE = actionGenerator.genActionTypes(
  `${PREFIX}_VALIDATE_CODE`
);

export const REQUEST_OTP = actionGenerator.genActionTypes(
  `${PREFIX}_REQUEST_OTP`
);

export const OTP_LOG = actionGenerator.genActionTypes(`${PREFIX}_OTP_LOG`);

export const VERIFY_OTP = actionGenerator.genActionTypes(
  `${PREFIX}_VERIFY_OTP`
);
export const REQUEST_LOGIN = actionGenerator.genActionTypes(
  `${PREFIX}_REQUEST_LOGIN`
);
export const UPDATE_USER_INFO = actionGenerator.genActionTypes(
  `${PREFIX}_UPDATE_USER_INFO`
);
export const REQUEST_GIGYA = actionGenerator.genActionTypes(
  `${PREFIX}_REQUEST_GIGYA`
);
export const EXCHANGE_CODE = actionGenerator.genActionTypes(
  `${PREFIX}_EXCHANGE_CODE`
);
export const TOPUP_MOBILE = actionGenerator.genActionTypes(
  `${PREFIX}_TOPUP_MOBILE`
);
//new
export const GET_STORE_BY_PHONE = actionGenerator.genActionTypes(
  `${PREFIX}_GET_STORE_BY_PHONE`
);
export const GET_CAMPAIGN_INFO = actionGenerator.genActionTypes(
  `${PREFIX}_GET_CAMPAIGN_INFO`
);

export const SUBMIT_WISH = actionGenerator.genActionTypes(
  `${PREFIX}_SUBMIT_WISH`
);

export const GET_GIFT_SUMMARY = actionGenerator.genActionTypes(
  `${PREFIX}_GET_GIFT_SUMMARY`
);

export const TAKE_GIFT = actionGenerator.genActionTypes(
  `${PREFIX}_TAKE_GIFT`
);

export const GET_BLOCK_LIST = actionGenerator.genActionTypes(
  `${PREFIX}_GET_BLOCK_LIST`
);
